import Vue from "vue";
import App from "./App";
import router from "./router";
import "font-awesome/css/font-awesome.min.css";
import "../src/assets/font/font.css";
// 引用element组件库
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// 引入全局样式
import "../src/styles/index.css";
// 引入swiper组件
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
// 引入加载组件
import GlobalLoading from "@/components/GlobalLoading";
Vue.component("GlobalLoading", GlobalLoading);
Vue.config.productionTip = false;
// 注册组件
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);

new Vue({
  el: "#app",
  router,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js